var React = require('react');

const tooltipPositions = {
    top: { bottom: '100%', left: '50%', transform: 'translateX(-50%)', marginBottom: 8 },
    right: { top: '50%', left: '100%', transform: 'translateY(-50%)', marginLeft: 8 },
    bottom: { top: '100%', left: '50%', transform: 'translateX(-50%)', marginTop: 8 },
    left: { top: '50%', right: '100%', transform: 'translateY(-50%)', marginRight: 8 },
};

class PasswordCriteriaChecklist extends React.Component {
    constructor(props) {
        super(props);
        this.previousValid = null;
    }

    componentDidUpdate(prevProps) {
        // Only proceed if password actually changed
        if (prevProps.password !== this.props.password) {
            const isValid = this.isPasswordValid();
            const prevValid = this.isPasswordValid(prevProps.password);

            // Only call onValidationChange if validation state changed
            if (prevValid !== isValid && this.props.onValidationChange) {
                this.props.onValidationChange(isValid);
            }
        }
    }

    isPasswordValid(passwordToCheck = null) {
        const { password } = this.props;
        const passwordValue = passwordToCheck !== null ? passwordToCheck : password;

        if (!passwordValue || passwordValue.length < 8 || passwordValue.length > 32) return false;
        const complexityChecks = [
            /[a-z]/.test(passwordValue),
            /[A-Z]/.test(passwordValue),
            /\d/.test(passwordValue),
            /[!@#$%^&*(),.?":{}|<>]/.test(passwordValue),
        ];
        const complexityMet = complexityChecks.filter(Boolean).length >= 3;
        return passwordValue.length >= 8 && complexityMet;
    }

    render() {
        const {
            password,
            passwordConfirm,
            asTooltip,
            tooltipPosition = 'bottom',
            open,
            children,
            showPasswordMatch = true,
        } = this.props;
        const validateLengthMinimum = value => value && value.length >= 8;
        const validateLengthMaximum = value => value && value.length <= 32;

        const complexityRequirements = [
            { name: "Contains at least one lowercase letter", valid: /[a-z]/.test(password) },
            { name: "Contains at least one uppercase letter", valid: /[A-Z]/.test(password) },
            { name: "Contains at least one number", valid: /\d/.test(password) },
            { name: "Contains at least one special character(@, #, $, %, etc.)", valid: /[!@#$%^&*(),.?":{}|<>]/.test(password) }
        ];

        const isComplex = complexityRequirements.reduce((a, c) => a + (c.valid ? 1 : 0), 0) >= 3;
        complexityRequirements.forEach(req => {
            req.className = req.valid ? 'valid' : isComplex ? 'inactive' : 'invalid';
        });

        const checklist = (
            <ul id="passwordChecklist">
                <li className={validateLengthMinimum(password) ? 'valid' : 'invalid'}>At least 8 characters.</li>
                <li className={validateLengthMaximum(password) ? 'valid' : 'invalid'}>No more than 32 characters.</li>
                <li className={isComplex ? 'valid' : 'invalid'}>
                    At least 3 of the following:
                    <ul>
                        {complexityRequirements.map((req, idx) => (
                            <li key={req.name + idx} className={req.className}>{req.name}</li>
                        ))}
                    </ul>
                </li>
                {showPasswordMatch && <li className={password && passwordConfirm === password ? 'valid' : 'invalid'}>Passwords match</li>}
            </ul>
        );

        const tooltipStyle = {
            ...(
                tooltipPositions[tooltipPosition] || tooltipPositions.bottom
            ),
        };

        return (
            <React.Fragment>
                {!asTooltip
                    ? <div>{checklist}</div>
                    : (
                        <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                            {children}
                            <div
                                className={`password-criteria-tooltip password-criteria-tooltip-${tooltipPosition} ${open ? "open" : ""}`}
                                style={tooltipStyle}
                            >
                                {checklist}
                            </div>
                        </div>
                    )
                }
            </React.Fragment>
        );
    }
}

module.exports = PasswordCriteriaChecklist;
